<template>
  <div>
    <a-modal v-drag-modal wrap-class-name="custom-modal-wrap" v-model="localVisible" title="物料选择" width="750px"
      :footer="null" @cancel="onCloseModel">
      <a-row :gutter="16">
        <a-col :span="24" style="width: 256px;">
          <a-input v-model="searchForm.search" placeholder="产品名称, 编码, 条码" allowClear @pressEnter="search" />
        </a-col>
        <a-space>
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-space>
      </a-row>

      <div style="margin-top: 12px;">
        <a-table :data-source="items" rowKey="id" :columns="columns" :loading="loading" :pagination="false"
          @change="onChangeTable" :scroll="{ y: tableHeight }">
          <div slot="action" slot-scope="value, item, index">
            <a-button size="small" @click="select(item)">选择</a-button>
          </div>
        </a-table>
      </div>

    </a-modal>
  </div>
</template>
<script>
import { inventoriesOption } from '@/api/option';
import { columns } from './columns';

export default {
  props: ['visible', 'warehouse'],
  model: { prop: 'visible', event: 'cancel' },
  data() {
    return {
      localVisible: this.visible,
      columns,
      searchForm: { search: '' },
      loading: false,
      items: [],
    }
  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.5; // 使用视窗高度的50%作为表格高度
    }
  },
  methods: {
    onCloseModel() {
      this.$emit('cancel', false);
    },
    onChangeTable(pagination, filters, sorter) {
      if (sorter && sorter.field) {
        this.searchForm.ordering = `${sorter.order == 'descend' ? '-' : ''}${sorter.field}`;
        this.list();
      }
    },
    search() {
      this.list();
    },
    list() {
      this.loading = true;
      inventoriesOption(this.searchForm).then(data => {
        this.items = data.results;
      }).finally(() => {
        this.loading = false;
      });
    },
    select(item) {
      this.$emit('select', item);
      this.onCloseModel();
    },
    resetModel() {
      this.searchForm = { warehouse: this.warehouse, is_active: true };
      this.items = [];
    },
  },
  watch: {
    visible(status) {
      this.localVisible = status;
      if (status) {
        this.resetModel();
        this.list();
      }
    },
  },
}
</script>